import styles from './HeroSection.module.css';

const GAP = -40;

const imgStyle = { mixBlendMode: 'screen' };

function HeroVisual({ spotlightPos, size = 140 }) {
  const imgH = Math.round(size * (141 / 140));

  const baseStyle = {
    position: 'absolute',
    width: size,
    height: imgH,
    pointerEvents: 'none',
    userSelect: 'none',
    zIndex: 0,
  };

  const pos = spotlightPos
    ? { left: spotlightPos.x - size / 2, top: spotlightPos.y - imgH - GAP }
    : { left: -9999, top: -9999 };

  return (
    <div style={{ ...baseStyle, ...pos }}>
      <img
        src="/assets/images/pin.png"
        alt="조명"
        className={styles.lightIcon}
        width={size}
        height={imgH}
        style={imgStyle}
      />
    </div>
  );
}

export default HeroVisual;
